<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="creategroup"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("new_dispatch") }}
            </h5>
            <p class="gray5">{{ $t("correct_info") }}</p>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="submit">
              <!-- <v-select class="custom-select mb-5" :options="options"></v-select> -->

              <div>
                <label v-if="showQuery">{{ $t("group_name") }}</label>
                <v-select
                  :filterable="false"
                  :options="options"
                  @search="onSearch"
                  v-model="inputVal"
                  v-if="showQuery"
                >
                  <template slot="no-options">
                    Type to search for customer details
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>

                <div class="form-group mb-0" v-else>
                  <label>{{ $t("group_name") }}</label>
                  <input
                    type="text"
                    name="group_name"
                    v-model="name"
                    class="form-control"
                    required
                    @keypress="isLetter($event)"
                  />
                </div>
                <span
                  @click="
                    showQuery = !showQuery;
                    clearInfo();
                  "
                  ><p class="mb-3 font-12 cursor-pointer" style="color:#213e7a">
                    {{
                      showQuery
                        ? "Click to enter name manually"
                        : "Click to Search for info"
                    }}
                  </p></span
                >
              </div>
              <div class="form-group">
                <label>{{ $t("address") }}</label>
                <input
                  type="text"
                  name="address"
                  v-model="address"
                  class="form-control"
                  required
                />
                <div class="d-flex justify-content-end mt-2">
                  <div
                    class="d-flex align-items-center"
                    style="column-gap:5px;"
                  >
                    <label class="mb-0 cursor-pointer" for="snooze">
                      {{ $t("snooze-dispatch") }}
                    </label>
                    <input
                      type="checkbox"
                      name="snooze"
                      id="snooze"
                      :checked="snooze"
                      class="snooze-check-box"
                      @change="snooze = !snooze"
                    />
                  </div>
                </div>
              </div>

              <div class="">
                <div class="form-group">
                  <label>{{ $t("email") }}</label>
                  <input
                    type="email"
                    name="email"
                    v-model="email"
                    class="form-control"
                    required
                    @change="validateEmail"
                    for="email"
                  />
                  <span v-if="msg"
                    ><p class="mb-3 font-12 error">{{ msg }}</p></span
                  >
                </div>

                <div class="form-group">
                  <label for="InputNumber">{{ $t("Phone Number") }}</label>
                  <div class="form-group">
                    <input class="form-control" type="tel" id="phone_number" />
                    <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                      {{ ErrorPhone }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("Start Date") }}</label>
                    <div class="d-flex" style="column-gap: 2px;">
                      <input
                        type="date"
                        name="minHumi"
                        class="form-control"
                        v-model="start_date"
                        style="max-width:10rem"
                        :min="new Date().toISOString().slice(0, 10)"
                      />
                      <!-- <div class="d-flex myForm">
                        <div class="input-group" style="min-width:2rem">
                          <select
                            class="form-control time_"
                            name="max-sms"
                            v-model="start_time"
                            required
                            style="border:0;border-radius: 5px 0 0px 5px;padding-right: 0px;"
                          >
                            <option
                              v-for="(time, i) in 11"
                              :value="time"
                              :key="i"
                              >{{ time + ":00" }}</option
                            >
                            <option :value="12" selected>12:00</option>
                          </select>
                        </div>
                        <div class="w-100 d-flex">
                          <select
                            class="form-control time_"
                            name="max-sms"
                            v-model="start_interval"
                            required
                            style="border: 0px;border-radius: 0px;min-width: 2rem;padding-right: 0;padding-left: 2px;"
                          >
                            <option value="AM" selected>{{ $t("AM") }}</option>
                            <option value="PM">{{ $t("PM") }}</option>
                          </select>
                          <div class="input-group-prepend">
                            <label
                              class="input-group-text append_"
                              for="inputGroupSelect01"
                            >
                              <i class="far fa-clock"></i>
                            </label>
                          </div>
                        </div>
                      </div> -->
                      <input
                        type="time"
                        v-model="start_time"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("End Date") }}</label>
                    <div class="d-flex" style="column-gap: 2px;">
                      <input
                        type="date"
                        name="minHumi"
                        class="form-control"
                        v-model="end_date"
                        style="max-width:10rem"
                        :min="start_date"
                        :disabled="!start_date || !start_time"
                      />
                      <!-- <div class="d-flex myForm">
                        <div class="input-group" style="min-width:2rem">
                          <select
                            class="form-control time_"
                            name="max-sms"
                            v-model="end_time"
                            required
                            style="border:0;border-radius: 5px 0 0px 5px;padding-right: 0px;"
                          >
                            <option
                              v-for="(time, i) in 11"
                              :value="time"
                              :key="i"
                              >{{ time + ":00" }}</option
                            >
                            <option :value="12" selected>12:00</option>
                          </select>
                        </div>
                        <div class="w-100 d-flex">
                          <select
                            class="form-control time_"
                            name="max-sms"
                            v-model="end_interval"
                            required
                            style="border: 0px;border-radius: 0px;min-width: 2rem;padding-right: 0;padding-left: 2px;"
                          >
                            <option value="AM" selected>{{ $t("AM") }}</option>
                            <option value="PM">{{ $t("PM") }}</option>
                          </select>
                          <div class="input-group-prepend">
                            <label
                              class="input-group-text append_"
                              for="inputGroupSelect01"
                            >
                              <i class="far fa-clock"></i>
                            </label>
                          </div>
                        </div>
                      </div> -->
                      <input
                        type="time"
                        v-model="end_time"
                        class="form-control"
                        :disabled="!start_date || !start_time"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="form-group mb-0"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="msg !== ''"
                >
                  {{ $t("next") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";
import moment from "moment";

export default {
  name: "AddDispatch",
  props: {
    show: Boolean,
    payload: Object,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      name: "",
      address: "",
      mssg: "",
      Errormssg: "",
      iti: "",
      start_time: "",
      end_interval: "PM",
      end_time: "",
      email: "",
      start_date: "",
      start_interval: "AM",
      ErrorPhone: "",
      end_date: "",
      inputVal: null,
      options: [],
      showQuery: true,
      msg: "",
      snooze: false,
    };
  },
  components: {
    Loading,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["addGroup", "fetchGroups", "searchContact"]),
    onCancel() {
      this.$emit("closeGroupModal");
    },
    submit() {
      let number = this.iti.getNumber().slice(1);
      if (!this.iti.isValidNumber()) {
        return (this.ErrorPhone = this.$t("valid_phone"));
      }
      const payload = {
        // startTime:
        //   this.start_date +
        //   " " +
        //   moment(`${this.start_time}${this.start_interval}`, ["h:mm A"]).format(
        //     "HH:mm"
        //   ),
        startTime:
          this.start_date +
          " " +
          moment(`${this.start_time}`, ["h:mm A"]).format("HH:mm"),
        endTime:
          this.end_date +
          " " +
          moment(`${this.end_time}`, ["h:mm A"]).format("HH:mm"),
        // endTime:
        //   this.end_date +
        //   " " +
        //   moment(`${this.end_time}${this.end_interval}`, ["h:mm A"]).format(
        //     "HH:mm"
        //   ),
        name: this.name,
        address: this.address,
        phone: parseInt(number).toString(),
        email: this.email,
        snooze: this.snooze,
      };
      // console.log(payload, 'payload')
      if (this.start_date === "" || this.start_time === "") {
        delete payload.startTime;
      }
      if (this.end_date === "" || this.end_time === "") {
        delete payload.endTime;
      }
      this.$emit("customer_details", payload);
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      vm.searchContact(`${escape(search)}`).then((res) => {
        loading(false);
        vm.options = res.data.data;
      });
    }, 350),
    clearInfo() {
      this.name = "";
      this.address = "";
      this.email = "";
      this.phone = "";
      this.iti.setNumber("");
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      // // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        this.msg = "";
      } else {
        this.msg = "Please enter a valid email address";
      }
    },
  },
  mounted() {
    setTimeout(() => {
      var input = document.querySelector("#phone_number");
      this.iti = intlTelInput(input, {
        separateDialCode: true,
        utilsScript: utils,
      });
      this.iti.setCountry("ng");
    }, 200);

    if (Object.keys(this.payload).length > 0) {
      const {
        address,
        email,
        name,
        phone,
        startTime,
        endTime,
        snooze,
      } = this.payload;
      // const starttimeSplit = moment(startTime.split(" ")[1], ["HH"])
      //   .format("hh A")
      //   .split(" ");
      // const endtimeSplit = moment(endTime.split(" ")[1], ["HH"])
      //   .format("hh A")
      //   .split(" ");
      //   console.log(startTime, 'startTime')
      //   console.log(starttimeSplit, 'split start')

      this.address = address;
      this.email = email;
      this.name = name;
      this.snooze = snooze;
      this.start_date = startTime.split(" ")[0];
      this.end_date = endTime.split(" ")[0];
      this.start_time = startTime.split(" ")[1];
      // this.start_interval = starttimeSplit[1];
      this.end_time = endTime.split(" ")[1];
      // this.end_interval = endtimeSplit[1];
      this.showQuery = false;

      var input = document.querySelector("#phone_number");
      this.iti = intlTelInput(input, {
        separateDialCode: true,
        utilsScript: utils,
      });
      var number = "+" + phone.toString();
      this.iti.setNumber(number);
    }
  },
  watch: {
    inputVal: {
      handler: function() {
        if (this.inputVal && Object.keys(this.inputVal).length > 1) {
          const { name, address, email, phone } = this.inputVal;
          this.name = name;
          this.address = address;
          this.email = email;
          this.iti.setCountry("ng");
          var number = "+" + phone.toString();
          this.iti.setNumber(number);
          if (!this.iti.isValidNumber()) {
            return this.iti.setNumber("");
          } else {
            var input = document.querySelector("#phone_number");
            this.iti = intlTelInput(input, {
              separateDialCode: true,
              utilsScript: utils,
            });
            number = "+" + phone.toString();
            this.iti.setNumber(number);
          }
        }
      },
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.modal-dialog {
  max-width: 500px !important;
}

.myForm {
  border: 1px solid #dadfe2;
  border-radius: 5px;
}
.append_ {
  background: white;
  border: 0;
  border-right: 1px solid #dadfe2;
  padding: 0 7px 0px 0px;
}
select.form-control.time_ {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
::-webkit-calendar-picker-indicator {
  margin-left: -18px;
}
.v-select ::v-deep .vs__dropdown-toggle {
  height: calc(1.5em + 1.2rem + 2px) !important;
  padding: 0.5rem 0.75rem !important;
}
.snooze-check-box {
  accent-color: #213e7a;
  cursor: pointer;
}
</style>

<i18n>
{
	"en": {
		"address": "Address",
		"avg_humid": "",
		"avg_temp": "Avg. Temp",
		"correct_info": "Kindly provide the correct information",
		"email": "Email",
		"group_monitor": "Group and monitor a selected cluster of devices in one view, instantly. Create a group to get started.",
		"group_name": "Customer Name",
		"new_dispatch": "New Dispatch",
		"next": "Next",
		"no_dev": "No device added",
		"no_group_yet": "You have no groups yet",
		"no_user": "No user added",
		"num_dev": "Number of Devices",
		"num_users": "Number of Users",
		"ur_groups": " Your groups will show here when the Admin assigns you to a Group.",
		"valid_phone": "Invalid Phone Number"
	},
	"fr": {
		"address": "Adresse",
		"avg_humid": "Moyenne. Humidité",
		"avg_temp": "Moy. Temp",
		"correct_info": "Veuillez fournir les informations correctes",
		"email": "Email",
		"group_monitor": "Regroupez et surveillez un groupe sélectionné d'appareils dans une seule vue, instantanément. Créez un groupe pour commencer.",
		"group_name": "Nom de groupe",
		"new_dispatch": "Nouveau groupe",
		"next": "Next",
		"no_dev": "Aucun appareil ajouté",
		"no_group_yet": "Vous n'avez pas encore de groupes",
		"no_user": "Aucun utilisateur ajouté",
		"num_dev": "Nombre d'appareils",
		"num_users": "Nombre d'utilisateurs",
		"ur_groups": "Vos groupes s'afficheront ici lorsque l'administrateur vous affectera à un groupe.",
		"valid_phone": "Invalid Phone Number"
	},
	"sw": {
		"address": "Anwani",
		"avg_humid": "",
		"avg_temp": "Wastani. Muda",
		"correct_info": "Tafadhali toa taarifa sahihi",
		"email": "Barua pepe",
		"group_monitor": "Panga na ufuatilie kundi lililochaguliwa la vifaa katika mwonekano mmoja, papo hapo. Unda kikundi ili uanze.",
		"group_name": "Jina la mteja",
		"new_dispatch": "Usambazaji Mpya",
		"next": "Ifuatayo",
		"no_dev": "Hakuna kifaa kilichoongezwa",
		"no_group_yet": "Bado huna vikundi",
		"no_user": "Hakuna mtumiaji aliyeongezwa",
		"num_dev": "Idadi ya Vifaa",
		"num_users": "Idadi ya Watumiaji",
		"ur_groups": " Vikundi vyako vitaonekana hapa Msimamizi atakapokukabidhi kwa Kikundi.",
		"valid_phone": "Nambari batili ya simu"
	}
}
</i18n>
